import { Grid } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import MainNavBar from "../../Components/Navbar/NavBar";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import AllMessagesContainer from "./AllMessagesContainer";
import MessagesMemberBox from "./MessagesMemberBox";

function Messages({ switchTheme, MAIN_USER }) {
    return (
        <div sx={{ overflow: "hidden" }}>
            <TopNavbar switchTheme={switchTheme} MAIN_USER={MAIN_USER} />
            <Grid container columns={12}>
                <Grid item md={4} xs={5}>
                    <MessagesMemberBox></MessagesMemberBox>
                </Grid>
                <Grid item md={8} xs={7}>
                    <Outlet />
                </Grid>
            </Grid>
        </div>
    );
}

export default Messages;
